<template>
  <LineChartGenerator
    :chart-options="chartOptions"
    :chart-data="chartData"
    :chart-id="chartId"
    :dataset-id-key="datasetIdKey"
    :plugins="plugins"
    :css-classes="cssClasses"
    :styles="styles"
    :width="width"
    :height="height"
    ref="canvas"
  />
</template>

<script>
import { Line as LineChartGenerator, mixin } from "vue-chartjs/legacy";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement
);

export default {
  name: "LineChart",
  components: {
    LineChartGenerator,
  },
  props: {
    chartId: {
      type: String,
      default: "line-chart",
    },
    datasetIdKey: {
      type: String,
      default: "label",
    },
    width: {
      type: Number,
      default: 200,
    },
    height: {
      type: Number,
      default: 400,
    },
    cssClasses: {
      default: "",
      type: String,
    },
    styles: {
      type: Object,
      default: () => {},
    },
    plugins: {
      type: Array,
      default: () => [
        {
          id: "tooltipLine",
          afterDraw: function (chart, easing) {
            if (chart.tooltip?._active?.length) {
              let x = chart.tooltip._active[0].element.x;
              let yAxis = chart.scales.y;
              let ctx = chart.ctx;
              ctx.save();
              ctx.beginPath();
              ctx.moveTo(x, yAxis.top);
              ctx.lineTo(x, yAxis.bottom);
              ctx.lineWidth = 1;
              ctx.strokeStyle = "#ff0000";
              ctx.stroke();
              ctx.restore();
            }
          },
        },
      ],
    },
  },
  data() {
    return {
      chartData: {
        labels: this.$store.state.dashboard.dashList.map((data) => {
          return data.date;
        }),
        datasets: [
          {
            label: "Cost",
            backgroundColor: "#8CD5FD",
            borderColor: "#8CD5FD",
            data: this.$store.state.dashboard.dashList.map((data) => {
              return data.cost;
            }),
          },
          {
            label: "Sales",
            backgroundColor: "#FDB48C",
            borderColor: "#FDB48C",
            data: this.$store.state.dashboard.dashList.map((data) => {
              return data.price;
            }),
          },
          {
            label: "Profit",
            backgroundColor: "#B7B9BD",
            borderColor: "#B7B9BD",
            data: this.$store.state.dashboard.dashList.map((data) => {
              return data.profit;
            }),
          },
          {
            label: "Profit%",
            backgroundColor: "#05523E",
            borderColor: "#05523E",
            data: this.$store.state.dashboard.dashList.map((data) => {
              return data.pfPercent;
            }),
          },
        ],
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        interaction: {
          intersect: false,
          mode: "index",
        },
      },
    };
  },
};
</script>
